/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UpdateContactMutationRequest, UpdateContactMutationResponse, UpdateContactPathParams, UpdateContactHeaderParams, UpdateContact401 } from "../../models/contactsController/UpdateContact";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateContactMutationKey = () => [{ url: '/contacts/:contactId' }] as const

export type UpdateContactMutationKey = ReturnType<typeof updateContactMutationKey>

/**
 * {@link /contacts/:contactId}
 */
export async function updateContact(contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams, config: Partial<RequestConfig<UpdateContactMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, UpdateContactMutationRequest>({ method : "PATCH", url : `/contacts/${contactId}`, data : requestData, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function updateContactMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateContactMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateContactMutationKey()
        return mutationOptions<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, {contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ contactId, data, headers }) => {
            return updateContact(contactId, data, headers, config)
          },
        })

}

/**
 * {@link /contacts/:contactId}
 */
export function useUpdateContact<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, {contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateContactMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateContactMutationKey()

          const baseOptions = updateContactMutationOptions(config) as UseMutationOptions<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, {contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams}, TContext>
          

          return useMutation<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, {contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateContactMutationResponse, ResponseErrorConfig<UpdateContact401>, {contactId: UpdateContactPathParams["contactId"], data: UpdateContactMutationRequest, headers?: UpdateContactHeaderParams}, TContext>
      
}